export default {"src":"/_next/static/media/3.f1f53eb3.svg","height":171,"width":305,"blurWidth":0,"blurHeight":0};